<!-- =========================================================================================
  File Name: Address.vue
  Description: Customer's address information
  ----------------------------------------------------------------------------------------
  Item Name: C4 - Store data for management
  Author: Oscar Ramírez O.
  Author URL: https://acentoNET.com
========================================================================================== -->


<template>
  <vs-popup fullscreen :active.sync="isAddressActiveLocal" title="Datos de dirección">
    <form-wizard
      ref="addressWizard"
      color="rgba(var(--vs-primary), 1)"
      :title="null"
      :subtitle="null"
      :hide-buttons="true"
      style="min-height: 600px;"
    >
      <tab-content title="Dirección completa" icon="feather icon-file-text">
        <div class="flex items-center justify-start mb-8">
          <p class="text-lg lg:text-2xl">Por favor escribe tu dirección completa y luego selecciona el departamento y municipio al que pertenece</p>
        </div>
        <div class="flex items-center w-full">
          <vs-input class="w-full" label-placeholder="Escribe tu dirección o un lugar cercano de referencia para ubicarlo en el mapa" v-model="address"/>
        </div>
        <div class="flex w-full mt-5">
          <v-select :options="states" label="name" clearable clearSearchOnSelect class="w-full" placeholder="Seleciona departamento" v-model="selectedState">
            <div slot="no-options">No se encontraron departamentos</div>
          </v-select>
        </div>
        <div class="flex w-full mt-5">
          <v-select :options="cities" label="name" clearable clearSearchOnSelect class="flex-1" placeholder="Seleciona municipio" v-model="selectedCity">
            <div slot="no-options">No se encontraron municipios</div>
          </v-select>
        </div>
        <div class="flex w-full items-center justify-end mt-5">
          <vs-button class="ml-2" color="primary" icon-pack="feather" icon="icon-chevron-right" @click="validateAddress">Siguiente</vs-button>
        </div>
      </tab-content>

      <tab-content title="Ubicación en mapa" icon="feather icon-map-pin">
        <div class="flex items-center justify-start mb-8">
          <p class="text-base lg:text-2xl">Hemos ubicado la dirección {{ selectedAddress }} en el mapa, si no está en el lugar exacto por favor arrastra el marcador hasta la ubicación exacta</p>
        </div>
        <div class="flex items-center justify-between">
          <gmap-map ref="map" :center="center" :zoom="zoom" class="flex w-full h-96 md:h-128">
            <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false" v-if="selectedPosition !== null">
              <div>
                <p><b>{{ selectedPosition.name }}</b></p>
                <p>{{ selectedPosition.address }}</p>
              </div>
            </gmap-info-window>
            <gmap-marker
              :key="i" v-for="(m,i) in markers"
              :position="m.position"
              :draggable="m.draggable"
              :clickable="true"
              :icon="m.icon"
              @click="toggleInfoWindow(m,i)"
              @dragend="afterDrag"
            ></gmap-marker>
          </gmap-map>
        </div>
        <div class="flex w-full items-center justify-betweeh mt-5">
          <vs-button class="ml-2" color="primary" icon-pack="feather" icon="icon-chevron-left" @click="$refs.addressWizard.prevTab()">Anterior</vs-button>
          <vs-spacer/>
          <vs-button class="ml-2" color="primary" icon-pack="feather" icon="icon-chevron-right" @click="validateLocation">Siguiente</vs-button>
        </div>
      </tab-content>
      <tab-content title="Guardar" icon="feather icon-save">
        <div class="flex items-center justify-start mb-8">
          <p class="text-base lg:text-2xl">Guardado dirección {{ selectedAddress }}</p>
        </div>
        <div class="flex items-center justify-start mb-8">
          <p class="text-lg lg:text-xl">Coloca un nombre a esta dirección</p>
        </div>
        <div class="flex items-center justify-between">
          <vs-input class="w-full" label-placeholder="Nombre para identificar esta dirección" v-model="name"/>
        </div>
        <div class="flex items-center justify-start mb-8">
          <p class="text-lg lg:text-xl">Indica alguna instrucción especial para ubicar la dirección a donde despachar</p>
        </div>
        <div class="flex items-center justify-between">
          <vs-input class="w-full" label-placeholder="Especifique instrucciones especiales de despacho" v-model="deliveryInstructions"/>
        </div>
        <div class="flex w-full items-center justify-betweeh mt-5">
          <vs-button class="ml-2" color="primary" icon-pack="feather" icon="icon-chevron-left" @click="$refs.addressWizard.prevTab()">Anterior</vs-button>
          <vs-spacer/>
          <vs-button class="ml-2" color="success" icon-pack="feather" icon="icon-save" @click="saveAddress">Guardar</vs-button>
        </div>
      </tab-content>
    </form-wizard>
    <vx-card class="flex flex-col h-80p w-full">
    </vx-card>
  </vs-popup>
</template>

<script>
  import {gmapApi} from 'vue2-google-maps';
  import {db} from '@/firebaseConfig';
  import {FormWizard, TabContent} from 'vue-form-wizard';
  import 'vue-form-wizard/dist/vue-form-wizard.min.css';
  import vSelect from 'vue-select';
  import states from '@/store/data/states.json';
  import cities from '@/store/data/cities.json';

  export default {
    props: {
      id: 0,
      email: '',
      currentAddress: null,
      isAddressActive: {
        type: Boolean,
        required: true
      }
    },
    components: {
      FormWizard,
      TabContent,
      'v-select': vSelect
    },
    data() {
      return {
        geocoder: null,
        center: {lat: 14.6027414, lng: -90.5212393},
        zoom: 14,
        infoContent: '',
        infoWindowPos: null,
        infoWinOpen: false,
        currentMidx: null,
        infoOptions: {
          pixelOffset: {width: 0, height: -35}
        },
        markers: [],
        selectedPosition: null,
        name: '',
        address: '',
        selectedState: {"id": 1, "name": "Guatemala"},
        selectedCity: {"id": 101, "stateId": 1, "name": "Guatemala"},
        fullAddress: '',
        deliveryInstructions: '',
        data: {
          id: 0,
          name: '',
          address: '',
          cityId: 0,
          cityName: '',
          stateId: 0,
          stateName: '',
          deliveryInstructions: ''
        },
      }
    },
    computed: {
      google: gmapApi,
      isAddressActiveLocal: {
        get() {
          return this.isAddressActive;
        },
        set(val) {
          if (!val) {
            this.$emit('closeAddress');
          }
        }
      },
      activeUserInfo() {
        return this.$store.state.AppActiveUser;
      },
      states() {
        return states.states;
      },
      cityList() {
        return cities.cities;
      },
      cities() {
        if (this.selectedState == null) {
          return [];
        } else {
          return cities.cities.filter(item => item.stateId == this.selectedState.id);
        }
      },
      selectedAddress() {
        if (this.address.trim() == '' || this.selectedState == null || this.selectedCity == null) {
          return '';
        } else {
          return `${this.address.trim()}, ${this.selectedState.name}, ${this.selectedCity.name}`;
        }
      }
    },
    watch: {
      isAddressActiveLocal: function () {
        if (this.isAddressActiveLocal) {
          this.initValues();
        }
      }
    },
    methods: {
      initValues() {
        if (this.currentAddress == null) {
          this.address = '';
          this.selectedState = {"id": 1, "name": "Guatemala"};
          this.selectedCity = {"id": 101, "stateId": 1, "name": "Guatemala"};
          this.deliveryInstructions = '';
          this.data = {
            id: 0,
            name: '',
            address: '',
            cityId: 0,
            cityName: '',
            stateId: 0,
            stateName: '',
            deliveryInstructions: ''
          };
        } else {
          this.id = this.currentAddress.id;
          this.name = this.currentAddress.name;
          this.address = this.currentAddress.address;
          var selectedState = this.states.filter(item => item.id == this.currentAddress.stateId);
          if (selectedState.length == 0) {
            this.selectedState = {"id": 1, "name": "Guatemala"};
            this.selectedCity = {"id": 101, "stateId": 1, "name": "Guatemala"};
          } else {
            this.selectedState = selectedState.pop();
            var selectedCity = this.cityList.filter(item => item.id == this.currentAddress.cityId);
            if (selectedCity.length == 0) {
              this.selectedCity = {"id": 101, "stateId": 1, "name": "Guatemala"};
            } else {
              this.selectedCity = selectedCity.pop();
            }
          }
          this.deliveryInstructions = this.currentAddress.deliveryInstructions;
          this.data = {
            id: this.currentAddress.id,
            name: this.currentAddress.name,
            address: this.currentAddress.address,
            cityId: this.currentAddress.cityId,
            cityName: this.currentAddress.cityName,
            stateId: this.currentAddress.stateId,
            stateName: this.currentAddress.stateName,
            deliveryInstructions: this.currentAddress.deliveryInstructions
          };
        }
        this.$refs.addressWizard.reset();
      },
      getPosition(position) {
        this.center = {lat: position.coords.latitude, lng: position.coords.longitude};
      },
      getCurrentPosition() {
        var self = this;
        navigator.geolocation.getCurrentPosition(
          position => {
            self.center = position.coords;
          },
          error => {
            this.$vs.notify({
              title: 'Error al buscar posición',
              text: error.message,
              color: 'warning',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              time: 8000
            });
          }
        )
      },
      toggleInfoWindow: function (marker, idx) {
        this.center = marker.position;
        this.infoWindowPos = marker.position;
        this.infoContent = marker.name;
        this.selectedPosition = marker;
        if (this.currentMidx == idx) {
          this.infoWinOpen = !this.infoWinOpen;
        } else {
          this.infoWinOpen = true;
          this.currentMidx = idx;
        }
      },
      validateAddress() {
        var self = this;
        if (this.address == '') {
          this.$vs.notify({
            title: 'Error al buscar dirección',
            text: 'Debes escribir una dirección',
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          });
        } else if (this.selectedState == null) {
          this.$vs.notify({
            title: 'Error al buscar dirección',
            text: 'Debes seleccionar un departamento',
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          });
        } else if (this.selectedCity == null) {
          this.$vs.notify({
            title: 'Error al buscar dirección',
            text: 'Debes seleccionar un municipio',
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          });
        } else {
          // this.fullAddress = `${this.address.trim()}, ${this.selectedState.name}, ${this.selectedCity.name}`;
          this.geocoder.geocode({'address': this.selectedAddress}, function (results, status) {
            if (status == this.google.maps.GeocoderStatus.OK) {
              self.center = results[0].geometry.location;
              self.zoom = 17;
              // var location = self.markers.filter(function(item) {return item.type == 'address'});
              var location = self.markers.find(item => item.type === 'address');
              if (location) {
                location.position = results[0].geometry.location;
                location.infoText = self.address;
                location.name = self.address;
              } else {
                self.markers.push({
                  type: 'address',
                  position: results[0].geometry.location,
                  draggable: true,
                  infoText: self.address,
                  name: self.address,
                  address: 'Por favor posiciona este marcador en la ubicación exacta de tu dirección'
                });
              }
              self.$refs.addressWizard.nextTab();
            } else {
              self.$vs.notify({
                title: 'Error al buscar dirección',
                text: 'No fue posible ubicar la dirección en el mapa, corrige la dirección o intenta con otra',
                color: 'danger',
                iconPack: 'feather',
                icon: 'icon-alert-circle'
              });
            }
          });
        }
      },
      validateLocation() {
        this.$refs.addressWizard.nextTab();
      },
      afterDrag(location) {
        this.center = location.latLng;
        var marker = this.markers.find(item => item.type === 'address');
        if (marker) {
          marker.position = location.latLng;
        }
      },
      saveAddress() {
        if (this.selectedAddress != '' && this.markers.length > 0) {
          var data = {
            id: this.id,
            name: this.name,
            address: this.address,
            stateId: this.selectedState.id,
            stateName: this.selectedState.name,
            cityId: this.selectedCity.id,
            cityName: this.selectedCity.name,
            deliveryInstructions: this.deliveryInstructions,
            lat: this.markers[0].position.lat(),
            lng: this.markers[0].position.lng()
          };
          this.$store.dispatch('addAddressUserInfo', {newAddress: (this.currentAddress == null), data: data});
          var self = this;
          db.collection('users').doc(this.email).update(self.activeUserInfo)
            .then(() => {
              self.$vs.notify({
                title: 'Información actualizada',
                text: 'La dirección fue guardada correctamente',
                color: 'success',
                iconPack: 'feather',
                icon: 'icon-info'
              });
              self.isAddressActiveLocal = false;
            })
            .catch((error) => {
              self.$vs.notify({
                title: 'Error al actualizar dirección',
                text: error,
                color: 'danger',
                iconPack: 'feather',
                icon: 'icon-alert-circle'
              });
            })
        }
      }
    },
    mounted() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.getPosition);
      }
      var self = this;
      this.$refs.map.$mapPromise.then(() => {
        self.geocoder = new self.google.maps.Geocoder();
      });
    }
  }
</script>
